'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./homePage/homePageDesigner'));
    processInclude(require('./product/swatchableTile'));

    if (('.video-card #myPlayerID').length > 0) {
        processInclude(require('./videoAnalytics'));
    }
});
